import { call, put, select, takeLatest } from 'redux-saga/effects'
import { FillablePDFsConstants } from '../store/fillablePDFs.constants'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setPdfError, setPdfLoading, setPdfUrl } from '../store/fillablePDFs.actions'
import type { IClientDataDoc } from '../../../services/clientData.service'
import { pdfBase64ToObjectUrl } from '../../../utilities/pdf.util'
import { FillablePdfsService } from '../services/fillablePdfs.service'

export function* loadPdfFromDeviceWorker(action: any) {
  const serviceId: string = yield select(getServiceIdSelector)
  const pdfDocId: string = action.pdfDocId

  if (!pdfDocId) return

  const localService = new FillablePdfsService(serviceId)

  try {
    yield put(setPdfLoading(true))

    const doc: IClientDataDoc | undefined | null = yield call(
      [localService, localService.getFillablePdfBlobDoc],
      pdfDocId
    )

    if (!doc || typeof doc.entity !== 'string' || !doc.entity.length) {
      yield put(setPdfError(`PDF not found in local storage for id=${pdfDocId}`))
      return
    }

    const objectUrl = pdfBase64ToObjectUrl(doc.entity)
    yield put(setPdfUrl(objectUrl))
    yield put(setPdfLoading(false))
  } catch (e) {
    yield put(setPdfLoading(false))
    yield put(setPdfError(String(e)))
    yield put(throwPcrException(`loadPdfFromDevice() error: ${e}`))
  }
}

export function* loadPdfFromDeviceSaga() {
  yield takeLatest([FillablePDFsConstants.LOAD_PDF_FROM_DEVICE], performWithMutexHOG, loadPdfFromDeviceWorker)
}
